import React from "react";
import { observer } from "mobx-react";
import { TenantPlanCreateStore } from "../../store";
import { TenantPlanCreateForm } from "./TenantPlanCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type TenantPlanCreateProps = {
  tenantPlanCreateStore: TenantPlanCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TenantPlanCreate: React.FC<TenantPlanCreateProps> = observer(
  ({ tenantPlanCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={tenantPlanCreateStore.isSaving} />
        <TenantPlanCreateForm
          tenantPlanCreateStore={tenantPlanCreateStore}
          name_esError={tenantPlanCreateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            tenantPlanCreateStore.setName_esValue(value);
          }}
          name_es={tenantPlanCreateStore.entityValues.name_es}
          name_enError={tenantPlanCreateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            tenantPlanCreateStore.setName_enValue(value);
          }}
          name_en={tenantPlanCreateStore.entityValues.name_en}
          name_ptError={tenantPlanCreateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            tenantPlanCreateStore.setName_ptValue(value);
          }}
          name_pt={tenantPlanCreateStore.entityValues.name_pt}
          description_esError={
            tenantPlanCreateStore.errors.description_es?.message
          }
          onDescription_esChange={(value: string) => {
            tenantPlanCreateStore.setDescription_esValue(value);
          }}
          description_es={tenantPlanCreateStore.entityValues.description_es}
          description_enError={
            tenantPlanCreateStore.errors.description_en?.message
          }
          onDescription_enChange={(value: string) => {
            tenantPlanCreateStore.setDescription_enValue(value);
          }}
          description_en={tenantPlanCreateStore.entityValues.description_en}
          description_ptError={
            tenantPlanCreateStore.errors.description_pt?.message
          }
          onDescription_ptChange={(value: string) => {
            tenantPlanCreateStore.setDescription_ptValue(value);
          }}
          description_pt={tenantPlanCreateStore.entityValues.description_pt}
          limitsError={tenantPlanCreateStore.errors.limits?.message}
          onLimitsChange={(value: string) => {
            tenantPlanCreateStore.setLimitsValue(value);
          }}
          limits={tenantPlanCreateStore.entityValues.limits}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={tenantPlanCreateStore.isProcessing}
          onSave={() => tenantPlanCreateStore.saveNewTenantPlan()}
          onCancel={() => tenantPlanCreateStore.cancelNewTenantPlan()}
        />
        <ErrorDialog
          open={tenantPlanCreateStore.errorDialogOpened}
          title={tenantPlanCreateStore.errorTitle}
          description={tenantPlanCreateStore.errorDescription}
          onClose={() => tenantPlanCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
